import styled from "@emotion/styled";
import { Box } from "@mui/material";

const CarouselRoot = styled(Box)(({ theme }) => ({
  position: "relative",
  width: "100%",
  maxWidth: "100%",
  padding: theme.spacing(2, 6),

  [theme.breakpoints.down("md")]: {
    padding: theme.spacing(1, 2),
  },
}));

const SlideContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  overflowY: "hidden",
  overflowX: "hidden",
  padding: theme.spacing(2),
  gap: theme.spacing(2),
  maxWidth: "100%",

  WebkitMaskImage:
    "linearGradient(to top, black 0%, black 100%), linear-gradient(to left, transparent 0%, black 100%), linear-gradient(to right, transparent 0%, black 100%)",
  WebkitMaskPosition: "center, left, right",
  WebkitMaskSize: "100% 100%, 20px 100%, 20px 100%",
  WebkitMaskRepeat: "no-repeat",
  WebkitMaskComposite: "source-out, source-over, source-over",

  maskImage:
    "linear-gradient(to top, black 0%, black 100%), linear-gradient(to left, transparent 0%, black 100%), linear-gradient(to right, transparent 0%, black 100%)",
  maskPosition: "center, left, right",
  maskSize: "100% 100%, 20px 100%, 20px 100%",
  maskRepeat: "no-repeat",
  maskComposite: "subtract, add, add",

  [theme.breakpoints.down("md")]: {
    margin: 0,
    padding: theme.spacing(1, 2),
  },
}));

export { CarouselRoot, SlideContainer };
